<template>
  <Transition name="slide-fade">
    <section v-show="!isHidden" id="privacy" class="privacy">
      <div @click="closeModal" class="privacy__close">
        <svg
          width="23"
          height="22"
          viewBox="0 0 23 22"
          fill=""
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill="#000"
            d="M1.954.04L22.46 20.546l-1.414 1.414L.54 1.454z"
          ></path>
          <path
            fill="#000"
            d="M.54 20.546L21.046.04l1.414 1.414L1.954 21.96z"
          ></path>
        </svg>
      </div>

      <div v-show="!isHidden" class="privacy__content">
        <h2>Политика в отношении обработки персональных данных</h2>

        <div class="privacy__content-item">
          <h4>1. Общие положения</h4>
          <p>
            1.1. Настоящая Политика по обработке персональных данных (далее -
            Положение) разработана в соответствии с Трудовым кодексом Российской
            Федерации, Конституцией Российской Федерации, Гражданским кодексом
            Российской Федерации, Федеральным законом «Об информации,
            информационных технологиях и о защите информации», Федеральным
            законом «О персональных данных», и определяет порядок обработки
            персональных данных и меры по обеспечению безопасности персональных
            данных ООО «Автобан Чери» (далее – Оператор).
          </p>
          <p>1.2. Цель разработки Политики :</p>
          <ul>
            <li>
              определение порядка обработки персональных данных работников,
              клиентов Организации и иных субъектов персональных данных,
              персональные данные которых подлежат обработке, на основании
              полномочий оператора;
            </li>
            <li>
              обеспечение защиты прав и свобод человека и гражданина, в т.ч.
              работника Организации, при обработке его персональных данных, в
              том числе защиты прав на неприкосновенность частной жизни, личную
              и семейную тайну, а также установление ответственности должностных
              лиц, имеющих доступ к персональным данным, за невыполнение
              требований норм, регулирующих обработку и защиту персональных
              данных.
            </li>
            <li>
              обеспечение работы сервисов веб-сайтов и сбор статистики посещения
              веб-сайтов, а также вывод релевантной рекламы
            </li>
            <li>подбор кандидатов на работу в Организации;</li>
            <li>сбор обратной связи;</li>
            <li>осуществление информационной рассылки;</li>
            <li>
              обеспечение соблюдения законодательства РФ (в т.ч. исполнение
              судебных актов);
            </li>
            <li>
              осуществление прав и законных интересов Организации или третьих
              лиц, либо достижение общественно значимых целей.
            </li>
          </ul>
          <p>
            Данная политика действует в отношении всех персональных данных
            (далее – данные), которые Организация может получить от субъекта
            персональных данных, являющегося стороной по гражданско-правовому
            договору, от пользователя сети Интернет (далее – Пользователь) во
            время использования им любого из сайтов, сервисов, служб, программ,
            продуктов или услуг, а также от субъекта персональных данных,
            состоящего с Оператором в отношениях, регулируемых трудовым
            законодательством.
          </p>
          <p>
            1.3. Настоящая Политика вступает в силу с момента его утверждения
            руководителем Организации и действует бессрочно, до замены его новым
            Положением.
          </p>
          <p>1.4. Все изменения в Политику вносятся приказом.</p>
        </div>
        <div class="privacy__content-item">
          <h4>2. Основные понятия и состав персональных данных</h4>
          <p>
            2.1. Для целей настоящего Политики используются следующие основные
            понятия:
          </p>
          <ul>
            <li>
              персональные данные - любая информация, относящаяся к
              определенному или определяемому на основании такой информации
              субъекту персональных данных, в том числе его фамилия, имя,
              отчество, год, месяц, дата и место рождения, адрес, семейное,
              социальное, имущественное положение, образование, профессия,
              доходы;
            </li>
            <li>
              обработка персональных данных сбор, систематизация, накопление,
              хранение, уточнение (обновление, изменение), использование,
              распространение (в том числе передача), обезличивание,
              блокирование, уничтожение персональных данных;
            </li>
            <li>
              конфиденциальность персональных данных - обязательное для
              соблюдения назначенного ответственного лица, получившего доступ к
              персональным данным , требование не допускать их распространения
              без согласия субъекта персональных данных или иного законного
              основания;
            </li>
            <li>
              распространение персональных данных - действия, направленные на
              передачу персональных данных определенному кругу лиц (передача
              персональных данных) или на ознакомление с персональными данными
              неограниченного круга лиц, в том числе обнародование персональных
              данных в средствах массовой информации, размещение в
              информационно-телекоммуникационных сетях или предоставление
              доступа к персональным данным каким-либо иным способом;
            </li>
            <li>
              использование персональных данных действия (операции) с
              персональными данными, совершаемые должностным лицом Организации в
              целях принятия решений или совершения иных действий, порождающих
              юридические последствия в отношении субъекта персональных данных
              либо иным образом затрагивающих их права и свободы или права и
              свободы других лиц;
            </li>
            <li>
              блокирование персональных данных - временное прекращение сбора,
              систематизации, накопления, использования, распространения
              персональных данных работников, в том числе их передачи;
              уничтожение персональных данных -действия, в результате которых
              невозможно восстановить содержание персональных данных в
              информационной системе персональных данных или в результате
              которых уничтожаются материальные носители персональных данных;
            </li>
            <li>
              обезличивание персональных данных - действия, в результате которых
              невозможно определить принадлежность персональных данных
              конкретному субъекту;
            </li>
            <li>
              общедоступные персональные данные - персональные данные, доступ
              неограниченного круга лиц к которым предоставлен с согласия
              субъекта персональных данных или на которые в соответствии с
              федеральными законами не распространяется требование соблюдения
              конфиденциальности;
            </li>
            <li>
              информация - сведения (сообщения, данные) независимо от формы их
              представления;
            </li>
            <li>
              документированная информация - зафиксированная на материальном
              носителе путем документирования информация с реквизитами,
              позволяющими определить такую информацию или ее материальный
              носитель. Оператор – организация, самостоятельно или совместно с
              другими лицами организующая обработку персональных данных, а также
              определяющая цели обработки персональных данных, подлежащих
              обработке, действия (операции), совершаемые с персональными
              данными. Оператором является лица, которым субъектом персональных
              данных предоставлено право на обработку персональных данных, в
              соответствии с согласием.
            </li>
          </ul>
        </div>
        <div class="privacy__content-item">
          <h4>3. Сбор, обработка и защита персональных данных</h4>
          <p>3.1. Порядок получения персональных данных.</p>
          <p>
            3.1.1. Все персональные данные следует получать от самого субъекта.
            Если персональные данные субъекта можно получить только у третьей
            стороны, то субъект должен быть уведомлен об этом или от него должно
            быть получено согласие.
          </p>
          <p>
            3.1.2. Оператор должен сообщить субъекту о целях, предполагаемых
            источниках и способах получения персональных данных, характере
            подлежащих получению персональных данных, перечне действий с
            персональными данными, сроке, в течение которого действует согласие,
            и порядке его отзыва, а также о последствиях отказа субъекта дать
            письменное согласие на их получение.
          </p>
        </div>
        <div class="privacy__content-item">
          <h4>4. Обработка персональных данных.</h4>
          <p>4.1. Обработка персональных данных осуществляется:</p>
          <ul>
            <li>
              с согласия субъекта персональных данных на обработку его
              персональных данных; в случаях, когда обработка персональных
              данных необходима для осуществления и выполнения возложенных
              законодательством РФ функций, полномочий и обязанностей;
            </li>
            <li>
              в случаях, когда осуществляется обработка персональных данных,
              доступ неограниченного круга лиц к которым предоставлен субъектом
              персональных данных либо по его просьбе (далее – персональные
              данные, сделанные общедоступными субъектом персональных данных).
            </li>
          </ul>
          <p>4.2. Цели обработки персональных данных:</p>
          <ul>
            <li>
              Обеспечение соблюдения законов, иных нормативно-правовых актов,
              проведения исследований рынка и опросов клиентов, направленных на
              улучшение качества товаров и оказываемых услуг по ремонту и
              техническому обслуживанию автомобилей, принадлежащих клиентам;
              проведение маркетинговых программ, статистических исследований, а
              также для продвижения товаров, в том числе путем осуществления
              прямых контактов с клиентами с помощью различных средств связи;
            </li>
            <li>исполнение договоров, заключенных с клиентами;</li>
            <li>
              проведение расчетов с клиентами; выполнение трудовых обязательств
              (обеспечения кадровой работы, подбор кадров, ведение личных дел
              сотрудников, начисление заработной платы, содействие работникам в
              трудоустройстве, получения образования, обучения и продвижения по
              службе);
            </li>
            <li>работа с жалобами, заявлениями граждан;</li>
            <li>подбора сотрудников;</li>
            <li>ведения кадрового учета сотрудников;</li>
            <li>
              ведения налоговой отчётности и осуществление взаиморасчётов с
              сотрудниками;
            </li>
            <li>направления сотрудников в командировки;</li>
            <li>
              оказания помощи в оформлении приглашений, разрешений на работу,
              рабочих и деловых виз для сотрудников;
            </li>
            <li>
              оформления полисов добровольного и обязательного медицинского
              страхования, и страхования от несчастных случаев на производстве
              для сотрудников; проведения медицинских осмотров сотрудников;
            </li>
            <li>
              ведения локальных и (или) общедоступных справочников сотрудников;
            </li>
            <li>ведение кадрового резерва;</li>
            <li>
              управления физическим доступом на территорию и в помещения
              оператора;
            </li>
            <li>обеспечения личной безопасности сотрудников;</li>
            <li>контроля количества и качества выполняемой работы;</li>
            <li>обеспечения сохранности имущества;</li>
            <li>
              содействия работникам в получении образования и продвижении по
              службе;
            </li>
            <li>управления логическим доступом к системам оператора;</li>
            <li>
              предоставления сервиса корпоративной мобильной связи сотрудникам;
            </li>
            <li>
              ведения локальных и/или общедоступных справочников контрагентов,
              клиентов оператора;
            </li>
            <li>оформления доверенностей на сотрудников;</li>
            <li>оформления доверенностей на представителей контрагентов;</li>
            <li>
              заключения договоров с контрагентами; организации предоставления
              пропусков для контрагентов и посетителей;
            </li>
            <li>организации обучения работников оператора и контрагентов;</li>
            <li>
              управление логическим доступом сотрудников оператора и третьих лиц
              в системах оператора;
            </li>
            <li>
              осуществления мероприятий отзыва автомобилей для устранения
              дефектов;
            </li>
            <li>
              проведения и организации проведения маркетинговых программ, в том
              числе для продвижения товаров, работ и услуг на рынке;
            </li>
            <li>
              проведения и организации проведения статистических исследований, а
              также исследований, направленных на улучшение качества товаров и
              услуг;
            </li>
            <li>
              оказания или организации оказания услуг потребителям автомобилей
              марок, представляемых оператором на российском рынке.
            </li>
          </ul>
          <p>4.3. Категории субъектов персональных данных.</p>
          <ul>
            <li>физические лица, являющиеся потенциальными клиентами;</li>
            <li>
              физические лица, состоящие в договорных и иных гражданско-правовых
              отношениях;
            </li>
            <li>
              контрагенты (физические лица и представители юридических лиц);
            </li>
            <li>посетители;</li>
            <li>сотрудники и члены семьи сотрудников;</li>
            <li>соискатели;</li>
            <li>
              стажеры, практиканты граждане, претендующие на замещение вакантной
              должности;
            </li>
            <li>граждане, обратившиеся с жалобами, заявлениями;</li>
            <li>лица состоящие в договорных отношениях.</li>
            <p>4.4. Персональные данные, обрабатываемые Оператором:</p>
            <ul>
              <li>
                данные, полученные при осуществлении трудовых отношений, данные,
                осуществления отбора кандидатов на работу, при осуществлении
                гражданско-правовых отношений, пот пользователей с помощью
                интернет-ресурса;
              </li>
              <li>биометрические персональные данные;</li>
              <li>
                фамилия, имя, отчество, дата рождения, место рождения, адрес,
                семейное положение, социальное положение, пол, имущественное
                положение, образование, профессия, доходы, состояние здоровья;
              </li>
              <li>реквизиты документов, удостоверяющих личность;</li>
              <li>табельный номер;</li>
              <li>ИНН;</li>
              <li>
                номер свидетельства государственного пенсионного страхования;
              </li>
              <li>полис обязательного медицинского страхования;</li>
              <li>сведения об отношении к воинской службе;</li>
              <li>гражданство;</li>
              <li>
                сведения о дате выдачи, сроке действия, серии, номере
                загранпаспорта, органе, выдавшем загранпаспорт;
              </li>
              <li>
                номер миграционной карты, сведения о сроке пребывания (для
                иностранных граждан);
              </li>
              <li>сведения о ближайших родственниках;</li>
              <li>
                свидетельства о рождении, заключении (расторжении) брака,
                свидетельства об изменении фамилии, имени, отчества,
                водительского удостоверения;
              </li>
              <li>номер домашнего телефона;</li>
              <li>номер мобильного телефона;</li>
              <li>рабочий адрес электронной почты;</li>
              <li>сведения о курсах повышения квалификации;</li>
              <li>сведения о владении иностранными языками;</li>
              <li>
                сведения о трудовом стаже и трудовой деятельности, включая даты,
                места работы и занимаемые должности;
              </li>
              <li>сведения о налоговых вычетах;</li>
              <li>сведения водительского удостоверения;</li>
              <li>
                сведения о банке, в котором субъект взял кредит на покупку
                автомобиля;
              </li>
              <li>
                сведения об автомобиле: VIN номер автомобиля, государственный
                номер автомобиля, марка, модель, год выпуска, дата приобретения;
                сведения о владельце автомобиля;
              </li>
              <li>
                сведения о проведении свободного времени, хобби, предпочитаемых
                журналах, радиостанциях, интернет-сайтах, телеканалах;
              </li>
              <li>фото-/видеоизображение;</li>
            </ul>
            <p>4.5. Обработка персональных данных ведется:</p>
            <ul>
              <li>с использованием средств автоматизации;</li>
              <li>без использования средств автоматизации.</li>
            </ul>
          </ul>
        </div>
        <div class="privacy__content-item">
          <h4>5. Передача и хранение персональных данных</h4>
          <p>
            5.1. При передаче персональных данных Организация должна соблюдать
            следующие требования:
          </p>
          <p>
            5.1.1. Не сообщать персональные данные третьей стороне без
            письменного согласия субъекта, за исключением случаев, когда это
            необходимо в целях предупреждения угрозы жизни и здоровью работника,
            а также в случаях, установленных федеральным законом.
          </p>
          <p>
            5.1.2. Не сообщать персональные данные в коммерческих целях без его
            письменного согласия.
          </p>
          <p>
            5.1.3. Предупредить лиц, получивших персональные данные, о том, что
            эти данные могут быть использованы лишь в целях, для которых они
            сообщены, и требовать от этих лиц подтверждения того, что это
            правило соблюдено. Лица, получившие персональные данные, обязаны
            соблюдать режим секретности (конфиденциальности).
          </p>
          <p>
            Разрешать доступ к персональным данным только специально
            уполномоченным лицам, установленных Приказом Организации, при этом
            указанные лица должны иметь право получать только те персональные
            данные, которые необходимы для выполнения конкретной функции.
          </p>
          <p>
            5.1.4. Осуществлять передачу персональных данных в пределах
            Организации в соответствии с настоящим Положением.
          </p>
        </div>
        <div class="privacy__content-item">
          <h4>6. Хранение персональных данных.</h4>
          <p>
            6.1. Персональные данные субъектов могут быть получены, проходить
            дальнейшую обработку и передаваться на хранение как на бумажных
            носителях, так и в электронном виде.
          </p>
          <p>
            6.2. Персональные данные, зафиксированные на бумажных носителях,
            хранятся в запираемых шкафах либо в запираемых помещениях с
            ограниченным правом доступа.
          </p>
          <p>
            6.3. Персональные данные субъектов, обрабатываемые с использованием
            средств автоматизации в разных целях, хранятся в разных папках.
          </p>
          <p>
            6.4. Не допускается хранение и размещение документов, содержащих
            персональных данных, в открытых электронных каталогах
            (файлообменниках) в ИСПД.
          </p>
          <p>
            6.5 Хранение персональных данных в форме, позволяющей определить
            субъекта персональных данных, осуществляется не дольше, чем этого
            требуют цели их обработки, и они подлежат уничтожению по достижении
            целей обработки или в случае утраты необходимости в их достижении.
          </p>
        </div>
        <div class="privacy__content-item">
          <h4>7. Передача персональных данных.</h4>
          <p>
            7.1. Оператор передает персональные данные третьим лицам в следующих
            случаях:
          </p>
          <ul>
            <li>субъект выразил свое согласие на такие действия;</li>
            <li>
              передача предусмотрена российским или иным применимым
              законодательством в рамках установленной законодательством
              процедуры.
            </li>
          </ul>
        </div>
        <div class="privacy__content-item">
          <h4>
            8. Основные права субъекта персональных данных и обязанности
            Оператора
          </h4>
          <p>
            8.1 Основные права субъекта персональных данных. Субъект имеет право
            на доступ к его персональным данным и следующим сведениям:
          </p>
          <ul>
            <li>
              подтверждение факта обработки персональных данных Оператором;
            </li>
            <li>правовые основания и цели обработки персональных данных;</li>
            <li>
              цели и применяемые Оператором способы обработки персональных
              данных;
            </li>
            <li>
              наименование и место нахождения Оператора, сведения о лицах (за
              исключением работников Оператора), которые имеют доступ к
              персональных данных или которым могут быть раскрыты персональные
              данные на основании договора с Оператором или на основании
              федерального закона;
            </li>
            <li>
              сроки обработки персональных данных, в том числе сроки их
              хранения;
            </li>
            <li>
              порядок осуществления субъектом персональных данных прав,
              предусмотренных Федеральным законом;
            </li>
            <li>
              наименование или фамилия, имя, отчество и адрес лица,
              осуществляющего обработку персональных данных по поручению
              Оператора, если обработка поручена или будет поручена такому лицу;
            </li>
            <li>обращение к Оператору и направление ему запросов;</li>
            <li>обжалование действий или бездействия Оператора.</li>
          </ul>
          <p>8.2. Обязанности Оператора.</p>
          <p>Оператор обязан:</p>
          <ul>
            <li>
              при сборе персональных данных предоставить информацию об обработке
              персональных данных;
            </li>
            <li>
              в случаях если персональные данные были получены не от субъекта
              персональных данных, уведомить субъекта;
            </li>
            <li>
              при отказе в предоставлении персональных данных субъекту
              разъясняются последствия такого отказа;
            </li>
            <li>
              опубликовать или иным образом обеспечитьнеограниченный доступ к
              документу, определяющему его политику в отношении обработки
              персональных данных, к сведениям о реализуемых требованиях к
              защите персональных данных;
            </li>
            <li>
              принимать необходимые правовые, организационные и технические меры
              или обеспечивать их принятие для защиты персональных данных от
              неправомерного или случайного доступа к ним, уничтожения,
              изменения, блокирования, копирования, предоставления,
              распространения персональных данных, а также от иных неправомерных
              действий в отношении персональных данных;
            </li>
            <li>
              давать ответы на запросы и обращения субъектовперсональных данных,
              их представителей и уполномоченного органа по защите прав
              субъектов персональных данных.
            </li>
          </ul>
        </div>
        <div class="privacy__content-item">
          <h4>9. Система защиты персональных данных.</h4>
          <p>
            Безопасность персональных данных при их обработке в информационных
            системах обеспечивается с помощью системы защиты персональных
            данных, включающей организационные меры и средства защиты информации
            (в том числе шифровальные (криптографические), средства
            предотвращения несанкционированного доступа, утечки информации по
            техническим каналам, программно-технических воздействий на
            технические средства обработки персональных данных), а также
            используемые в информационной системе информационные технологии.
          </p>
          <p>
            При обработке персональных данных в информационных системах Компании
            должно быть обеспечено:
          </p>
          <ul>
            <li>
              Проведение мероприятий, направленных на предотвращение
              несанкционированного доступа к персональным данным и (или)
              передачи их лицам, не имеющим права доступа к такой информации.
            </li>
            <li>
              Своевременное обнаружение фактов несанкционированного доступа к
              персональным данным.
            </li>
            <li>
              Недопущение воздействия натехнические средства автоматизированной
              обработки персональных данных, в результате которого может быть
              нарушено их функционирование.
            </li>
            <li>
              Возможность незамедлительного восстановления персональных данных,
              модифицированных или уничтоженных вследствие несанкционированного
              доступа к ним.
            </li>
            <li>
              Постоянный контроль над обеспечением уровня защищенности
              персональных данных
            </li>
          </ul>
        </div>
        <div class="privacy__content-item">
          <h4>
            10. Ответственность за нарушение норм, регулирующих обработку и
            защиту персональных данных
          </h4>
          <p>
            10.1 Работники Организации, виновные в нарушении норм, регулирующих
            получение, обработку и защиту персональных данных субъекта, несут
            дисциплинарную административную, гражданско-правовую или уголовную
            ответственность в соответствии с федеральными законами.
          </p>
        </div>
      </div>
    </section>
  </Transition>
</template>

<script>
export default {
  data() {
    return {
      isHidden: true,
    };
  },
  methods: {
    closeModal() {
      this.isHidden = true;
    },
  },
  mounted() {
    this.emitter.on("open-privacy", (data) => {
      this.isHidden = data.open;
    });
  },
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}
</style>
